import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import useTranslation from 'shared/useTranslation';
import { useLoginMutation } from 'store/auth/auth.api';
import { LoginFormFields } from './types';

// A 429 already gets a dedicated toast from throttleMiddleware; showing
// "wrong credentials" on top of it would be misleading (the credentials were never checked).
const isThrottled = (error: unknown) => (error as FetchBaseQueryError)?.status === 429;

export const useLoginAuth = () => {
  const [translations] = useTranslation(['login.form.sign.in.error'] as const);
  const [login, rest] = useLoginMutation();

  const loginSubmit = useCallback(
    async (values: LoginFormFields) => {
      try {
        await login(values).unwrap();
      } catch (error) {
        if (!isThrottled(error)) {
          toast.error(translations.loginFormSignInError);
        }
      }
    },
    [login, translations.loginFormSignInError],
  );

  return [loginSubmit, rest] as const;
};
